import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useApp } from '../../context/AppContext';
import api from '../../services/api';

const VideosManager = () => {
    const { videos, fetchVideos, showToast } = useApp();
    const [search, setSearch] = useState('');
    const navigate = useNavigate();

    const filteredVideos = videos.filter(video =>
        video.title.toLowerCase().includes(search.toLowerCase()) ||
        (video.description && video.description.toLowerCase().includes(search.toLowerCase()))
    );

    const handleDelete = async (id) => {
        if (window.confirm('Are you sure you want to delete this video?')) {
            try {
                await api.delete(`/videos/${id}`);
                await fetchVideos();
                showToast('Video deleted successfully');
            } catch (error) {
                showToast('Error deleting video', 'error');
            }
        }
    };

    return (
        <div style={{ background: '#fff', borderRadius: '8px', padding: '24px', boxShadow: '0 1px 6px rgba(0,0,0,.08)' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', flexWrap: 'wrap', gap: '10px' }}>
                <h3 style={{ margin: 0 }}>All Videos</h3>
                <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                    <input
                        type="text"
                        placeholder="Search videos..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        style={{ border: '1.5px solid #ddd', borderRadius: '5px', padding: '8px 12px', fontSize: '13px', outline: 'none', width: '250px' }}
                    />
                    <button className="btn btn-navy btn-sm" onClick={() => navigate('/admin/add-video')}>+ Add Video</button>
                </div>
            </div>
            <div style={{ overflowX: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                        <tr style={{ background: 'var(--navy)', color: '#fff' }}>
                            <th style={{ padding: '10px 12px', textAlign: 'left' }}>Thumbnail</th>
                            <th style={{ padding: '10px 12px', textAlign: 'left' }}>Title / Description</th>
                            <th style={{ padding: '10px 12px', textAlign: 'left' }}>Category</th>
                            <th style={{ padding: '10px 12px', textAlign: 'left' }}>Views</th>
                            <th style={{ padding: '10px 12px', textAlign: 'left' }}>Status</th>
                            <th style={{ padding: '10px 12px', textAlign: 'left' }}>Date</th>
                            <th style={{ padding: '10px 12px', textAlign: 'left' }}>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredVideos.map(video => (
                            <tr key={video._id}>
                                <td style={{ padding: '10px 12px', borderBottom: '1px solid #f0f0f0' }}>
                                    <img
                                        src={video.thumb || video.thumbData}
                                        alt=""
                                        style={{ width: '60px', height: '40px', objectFit: 'cover', borderRadius: '3px' }}
                                        onError={(e) => e.target.style.display = 'none'}
                                    />
                                </td>
                                <td style={{ padding: '10px 12px', borderBottom: '1px solid #f0f0f0', maxWidth: '350px' }}>
                                    <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>{video.title}</div>
                                    {video.description && (
                                        <div style={{ fontSize: '11px', color: '#888', lineHeight: '1.4' }}>
                                            {video.description.substring(0, 80)}...
                                        </div>
                                    )}
                                </td>
                                <td style={{ padding: '10px 12px', borderBottom: '1px solid #f0f0f0' }}>{video.category}</td>
                                <td style={{ padding: '10px 12px', borderBottom: '1px solid #f0f0f0' }}>
                                    <strong>{video.views?.toLocaleString() || 0}</strong>
                                </td>
                                <td style={{ padding: '10px 12px', borderBottom: '1px solid #f0f0f0' }}>
                                    <span className={`badge ${video.status === 'live' ? 'status-live' : 'status-draft'}`}>
                                        {video.status}
                                    </span>
                                </td>
                                <td style={{ padding: '10px 12px', borderBottom: '1px solid #f0f0f0' }}>{video.date}</td>
                                <td style={{ padding: '10px 12px', borderBottom: '1px solid #f0f0f0' }}>
                                    <button className="action-btn action-edit" onClick={() => navigate(`/admin/edit-video/${video._id}`)}>
                                        Edit
                                    </button>
                                    <button className="action-btn action-del" onClick={() => handleDelete(video._id)}>
                                        Delete
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default VideosManager;